const isToday = (dayString: string): boolean => {
  // Create an array of day names in lowercase
  const daysOfWeek = [
    'sunday',
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
  ]

  // Get the current day of the week as a number (0 = Sunday, 1 = Monday, ..., 6 = Saturday)
  const currentDayNumber = new Date().getDay()

  // Get the day name from the array using the current day number
  const currentDay = daysOfWeek[currentDayNumber]

  // Compare the input string with the current day (case-insensitive)
  return dayString.toLowerCase() === currentDay
}

export default isToday
